(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FV-lightroom"]) return;
  try {
    

let presetToShow = 8;

let randomSelectedPreset = [];

let allPresetTitles = document.getElementsByClassName("hpPresetTile");
let allPresetTitlesArray = Array.from(allPresetTitles);


for (let i = 0; i < presetToShow; i++) { 
	let randomIndex = Math.floor(Math.random()*allPresetTitlesArray.length)
	randomSelectedPreset.push(allPresetTitlesArray[randomIndex])

	//Then remove it so we don't end up with any duplicates
	allPresetTitlesArray.splice(randomIndex, 1)
}

// Finally hide any of the preset tiles left after
for (let presetTile of allPresetTitlesArray) {
	presetTile.classList.add("displayNone")
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FV-slider"]) return;
  try {
    

  $(document).on('click', '.js-go-curbon-plus-message', function(e) {
  	e.preventDefault();
  	const top = $('#message').offset().top;
  	$("html,body").animate({scrollTop:top},300);
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dev-homepage"]) return;
  try {
    


	// When the user scrolls down 100px from the top of the document, show the button
	window.onscroll = function() {
  		scrollFunction()
  
  	};

    function scrollFunction() {
        if (document.body.scrollTop > 600 || document.documentElement.scrollTop > 600) {
            document.getElementById("backToTopButton").style.display = "block";
        } else {
            document.getElementById("backToTopButton").style.display = "none";
        }
    }


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movie-list-template"]) return;
  try {
    

$(function(){
	$('.movieList__movies').scroll(function() {
		var maxScrollValue = $(this).get(0).scrollWidth - $(this).get(0).clientWidth;
		var itemLength = $(this).children(".movieList__movie").length;
		var oneScrollWidth = Math.round(maxScrollValue / itemLength);
		
		var current = Math.ceil($(this).scrollLeft() / oneScrollWidth);

		if (0 < current) {
			$(this).next().children(`.movieList__point--active`).removeClass("movieList__point--active");
			$(this).next().children(`.movieList__point:nth-child(${current})`).addClass("movieList__point--active");
		}
		
	})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presets-template"]) return;
  try {
    
	initComparisons();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-amazaki-gallery"] && !Shopify.designMode) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-atsuya-gallery"] && !Shopify.designMode) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-c-plus-guidance"]) return;
  try {
    

$(function(){
	$('.movieList__movies').scroll(function() {
		var maxScrollValue = $(this).get(0).scrollWidth - $(this).get(0).clientWidth;
		var itemLength = $(this).children(".movieList__movie").length;
		var oneScrollWidth = Math.round(maxScrollValue / itemLength);
		
		var current = Math.ceil($(this).scrollLeft() / oneScrollWidth);

		if (0 < current) {
			$(this).next().children(`.movieList__point--active`).removeClass("movieList__point--active");
			$(this).next().children(`.movieList__point:nth-child(${current})`).addClass("movieList__point--active");
		}
		
	})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-fiveon-gallery"]) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-fiveon-lightroom"]) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-fiveon-online"]) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-fiveon-photoshoot"]) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-fiveon-radio"]) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-fiveon-video"]) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-hashimoto-gallery"] && !Shopify.designMode) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-kohara-gallery"] && !Shopify.designMode) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-sara-gallery"] && !Shopify.designMode) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-takei-gallery"] && !Shopify.designMode) return;
  try {
    
initComparisons();



  } catch(e) { console.error(e); }
})();
})();
